const UPDATE_FRAME_MS = 0.1

/**
 * Waits until predicate becomes true or fails by timing out
 * @param {function} predicate Function to evaluate
 * @param {number} timeout Max time to wait for predicate to be true
 * @returns {Promise}
 */
export async function waitFor (predicate, timeout = 60) {
  let elapsed = 0
  while (timeout >= elapsed) {
    await sleep(UPDATE_FRAME_MS)
    elapsed += UPDATE_FRAME_MS
    if (predicate()) {
      return true
    }
  }
  return false
}

/**
 * Waits until the given element fires the event name automatically binding and
 * unbinding the event listener or fails by timing out
 * @param {HTMLElement} element Element to wait for event on
 * @param {string} eventName Name of event to wait for
 * @param {number} timeout Max time to wait for event to fire
 * @returns {Promise}
 */
export async function waitForEvent(element, eventName, timeout = 60) {
  return new Promise((resolve, reject) => {
    const listener = (event) => {
      element.removeEventListener(eventName, listener)
      resolve(event)
    }
    element.addEventListener(eventName, listener)
    setTimeout(() => {
      element.removeEventListener(eventName, listener)
      reject(new Error(`Timeout waiting for event ${eventName}`))
    }, timeout * 1000)
  })
}

async function sleep (seconds = 0.1) {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000))
}
